import * as React from "react";
import { AnalyticsConfig } from "uitk-react-utils";
import { UitkCarousel } from "uitk-react-carousel";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { formatText } from "bernie-l10n";

import { DestinationAttractionsProps } from "./typings";
import { Attraction } from "typings/microserviceModels/destination-attractions-flex-module";
import { AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { AttractionCard } from "./AttractionCard";

export const AttractionSection = ({
  attractions,
  attractionsKeyHelper,
  props,
  headingKey,
  carouselAnalytics,
  isCountry,
  isActivity
}: {
  attractions: Attraction[];
  attractionsKeyHelper: ItemKeyHelper;
  props: DestinationAttractionsProps;
  headingKey: string;
  carouselAnalytics?: AnalyticsConfig;
  isCountry: boolean;
  isActivity: boolean;
}) => {
  const desktopAttractions = attractions.filter(
    (poi, index) => (attractions.length >= 6 ? index < 6 : index < 3)
  );

  return (
    <Viewport>
      <ViewSmall>
        <UitkCarousel
          headline={
            props.context.searchContext.location.localizedName &&
            formatText(headingKey, props.context.searchContext.location.localizedName)
          }
          analytics={carouselAnalytics}
          carouselName={isActivity ? "Activities" : "Pois"}
          buttonText={{
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev")
          }}
          {...carouselProps}
        >
          {attractions.map((attraction, attractionIndex) => (
            <AttractionCard
              key={attractionsKeyHelper.next()}
              attraction={attraction}
              imageUrl={safelyResizeImage(attraction, props)}
              position={attractionIndex + 1}
              context={props.context}
              uitkCardClassNames={
                "uitk-carousel-item uitk-flex-justify-content-flex-start uitk-flex-column"
              }
              isCountry={isCountry}
              isActivity={isActivity}
              attractionsKeyHelper={attractionsKeyHelper}
            />
          ))}
        </UitkCarousel>
      </ViewSmall>
      <ViewLarge>
        <div className="all-b-margin-three">
          <h3 className="uitk-type-heading-600 all-b-margin-three">
            {props.context.searchContext.location.localizedName &&
              formatText(headingKey, props.context.searchContext.location.localizedName)}
          </h3>
          <div className="uitk-grid all-cell-1-3 all-x-gutter-three">
            {desktopAttractions.map((attraction, attractionIndex) => (
              <div className="uitk-cell all-b-margin-three" key={attractionsKeyHelper.next()}>
                <AttractionCard
                  attraction={attraction}
                  imageUrl={safelyResizeImage(attraction, props)}
                  position={attractionIndex + 1}
                  context={props.context}
                  uitkCardClassNames={"attraction-card-desktop"}
                  isCountry={isCountry}
                  isActivity={isActivity}
                  attractionsKeyHelper={attractionsKeyHelper}
                />
              </div>
            ))}
          </div>
        </div>
      </ViewLarge>
    </Viewport>
  );
};

export const carouselProps = {
  itemsVisible: { lg: 1, md: 1, sm: 1 },
  pageBy: 1,
  peekWidth: 24
};

export const safelyResizeImage = (attraction: Attraction, props: DestinationAttractionsProps) => {
  const image: string = attraction.media && attraction.media.mediaUrl;

  return image && props.thumbor
    ? props.thumbor.safelyGenerateThumborizedImageUrl(
        image,
        340,
        192,
        props.context,
        AspectRatioEnum.DEFAULT,
        true,
        100
      )
    : image;
};
